import * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// value/onChange trafegam como string decimal ("1234.56"), igual ao que a API espera.
function centsToDecimal(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (!digits) return "";
  return (parseInt(digits, 10) / 100).toFixed(2);
}

function formatDisplay(decimal: string): string {
  const n = Number(decimal);
  if (!decimal || Number.isNaN(n)) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

interface CurrencyInputProps
  extends Omit<React.ComponentProps<"input">, "value" | "onChange" | "type"> {
  value: string;
  onChange: (value: string) => void;
}

const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ value, onChange, className, ...props }, ref) => {
    return (
      <div className="relative">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
          R$
        </span>
        <Input
          {...props}
          ref={ref}
          inputMode="numeric"
          className={cn("pl-9", className)}
          value={formatDisplay(value)}
          onChange={(e) => onChange(centsToDecimal(e.target.value))}
        />
      </div>
    );
  },
);
CurrencyInput.displayName = "CurrencyInput";

export { CurrencyInput };
